import React, { useRef } from 'react'
import { DialogTitle, DialogContent, Dialog } from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import Draggable from 'react-draggable'
import DialogTitleHeaderComponent from '../common/dialog-title-header.component'
import stylesheet from '../detail-container.stylesheet'
import { SiteManager } from '../../../sites'

interface IProps {
  open: boolean
  item?: any
  handleDialogClose: any
  handleUpdateSiteList?: any
  onSelectSite?: (site: any) => void
  classes: ClassNameMap
}

const SiteDialogComponent: React.FC<IProps> = ({ open, item, handleDialogClose, handleUpdateSiteList, onSelectSite, classes }) => {
  const isAddPrRef = useRef(null) as any
  const isSelectMode = item?.isSelectMode || false

  const handleCloseSite = () => {
    handleUpdateSiteList?.()
    handleDialogClose()
  }

  return (
    <Draggable ref={isAddPrRef} defaultPosition={{ x: 0, y: 0 }} handle=".add-site-dialog">
      <Dialog
        id={item.title}
        fullWidth={true}
        maxWidth="lg"
        open={open}
        onClose={handleCloseSite}
        aria-labelledby={item.title}
        hideBackdrop
        disableScrollLock
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.stopPropagation()
          }
        }}
        onKeyUp={(e) => {
          if (e.key === 'Enter') {
            e.stopPropagation()
          }
        }}
        sx={{ position: 'absolute', left: '10%', top: '15%' }}
      >
        <DialogTitle className={classes.addPatientQuestionHeaderSection} classes={{ root: 'add-site-dialog' }}>
          <DialogTitleHeaderComponent title={item?.title} handleDialogClose={handleCloseSite} />
        </DialogTitle>

        <DialogContent className={classes.addPatientDialogContent} sx={{ minHeight: '30rem !important', p: 0 }}>
          <SiteManager
            input={{ isAddSite: true }}
            onSelectSite={
              isSelectMode
                ? (site) => {
                    onSelectSite?.(site)
                    handleDialogClose()
                  }
                : undefined
            }
          />
        </DialogContent>
      </Dialog>
    </Draggable>
  )
}

export default withStyles(stylesheet)(SiteDialogComponent)
